import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from '../components/nav/Navbar';
import { GlobalStyles } from '../components/globalStyles/Global.styles';
import Home from '../pages/home/Home'
import Login from '../pages/login/Login'
import Register from '../pages/register/Register'
import About from '../pages/about/About'
import Detail from '../pages/detail/Detail'
import PrivateRouter from './PrivateRouter';


const AppRouter = () => {
  return (
    <BrowserRouter>
      <GlobalStyles />
      <Navbar />
      <Routes>
        <Route path='/' element = {<Home/>} />
        {/* relative path */}
        <Route path='login' element = {<Login/>} />
        <Route path='register' element = {<Register/>} />
        
        <Route path='about' element={<PrivateRouter />}>
          <Route path='' element = {<About/>} />
        </Route>
        <Route path='detail' element={<PrivateRouter />}>
          <Route path='' element = {<Detail/>} />
        </Route>
      
      </Routes>
    </BrowserRouter>
  )
}

export default AppRouter;